function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2611",
  "data-name": "Group 2611",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_489",
  "data-name": "Line 489",
  x2: 10.53,
  transform: "translate(0.055 4.374)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_490",
  "data-name": "Line 490",
  x2: 0.005,
  transform: "translate(7.941 6.682)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_491",
  "data-name": "Line 491",
  x2: 0.005,
  transform: "translate(5.32 6.682)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_492",
  "data-name": "Line 492",
  x2: 0.005,
  transform: "translate(2.693 6.682)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_493",
  "data-name": "Line 493",
  x2: 0.005,
  transform: "translate(7.941 8.977)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_494",
  "data-name": "Line 494",
  x2: 0.005,
  transform: "translate(5.32 8.977)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_495",
  "data-name": "Line 495",
  x2: 0.005,
  transform: "translate(2.693 8.977)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_496",
  "data-name": "Line 496",
  y2: 1.944,
  transform: "translate(7.706)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_497",
  "data-name": "Line 497",
  y2: 1.944,
  transform: "translate(2.934)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4193",
  "data-name": "Path 4193",
  d: "M7.821,1.579h-5A2.542,2.542,0,0,0,0,4.322V9.669a2.566,2.566,0,0,0,2.819,2.793h5a2.544,2.544,0,0,0,2.819-2.749V4.322A2.533,2.533,0,0,0,7.821,1.579Z",
  transform: "translate(0 -0.646)",
  fill: "none",
  stroke: "#f6c244",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}));

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.634,
    height: 12.816,
    viewBox: "0 0 11.634 12.816",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.ba6b86cb.svg";
export { ForwardRef as ReactComponent };